import React, { useEffect, useRef } from 'react';
import { makeStyles } from '@mui/styles';
import { OktaAuth as OktaAuthService, UISettings } from '../../data/auth-service';
import OktaSignIn from '@okta/okta-signin-widget';
import PropTypes from 'prop-types';
import { useOktaAuth } from '@okta/okta-react';
import { TranslateHome } from '../../libraries/helpers';
import { get as _get } from 'lodash';
import Grid from '@mui/material/Grid';
import CircularProgress from '@mui/material/CircularProgress';

// un-hide the remember me checkbox in the Okta widget
// this has been bothering me for a while
const useStyles = makeStyles(theme => ({
    oktaWidget: {
        '& #okta-sign-in .custom-checkbox input': {
            opacity: 1,
        }
    },
}));

const OktaLoginWidgetWrapper = ({ onSuccess, onError }) => {
    const signinWidgetRef = useRef();
    const classes = useStyles();

    const oktaConf = {
        baseUrl: UISettings.settings.auth.okta.base_url,
        clientId: UISettings.settings.auth.okta.client_id,
        redirectUri: window.location.origin + '/signin/callback',
        useInteractionCodeFlow: false,
        authParams: {
            issuer: UISettings.settings.auth.okta.issuer,
            pkce: true,
            responseMode: 'fragment',
            scopes: ['openid', 'profile', 'email', 'groups'],
        },
        features: {
            useClassicEngine: true,
        },
    };

    useEffect(() => {
       
        if (!signinWidgetRef.current) {
            return false;
        }

        const widget = new OktaSignIn(oktaConf);
        const searchParams = new URL(window.location.href).searchParams;
        widget.otp = searchParams.get('otp');
        widget.state = searchParams.get('state');
        widget.showSignInToGetTokens({
            el: signinWidgetRef.current,
        }).then(onSuccess).catch(onError);

        return () => widget.remove();
    }, [onSuccess, onError]);

    return (<div className={classes.oktaWidget} ref={signinWidgetRef} />);
};

OktaLoginWidgetWrapper.propTypes = {
    onSuccess: PropTypes.func.isRequired,
    onError: PropTypes.func.isRequired,
};

const OktaLogin = ({ config }) => {
    const { oktaAuth, authState } = useOktaAuth();

    const handleSuccess = (tokens) => {
        try {
            OktaAuthService.Login(tokens).then(res => {
                const home = TranslateHome(_get(res, 'user.data.profile.home', '/'));
                oktaAuth.handleLoginRedirect(tokens, home);
            }, err => {
                console.error('Unable to log in Okta user ::: ', err);
            });
        } catch (e) {
            console.error("Error in decoding the token", e)
        }
    };

    const handleError = (err) => {
        console.error('Unable to login using Okta ::: ', err);
        if (err && err.errorCode) {
            alert(`Okta error: ${err.errorCode} - ${err.message}`);
        }
    };

    if (!authState) {
        return (
            <Grid container direction="column" justifyContent="center" alignItems="center">
                <div>Processing response</div>
                <CircularProgress />
            </Grid>
        );
    }

    return (
        <Grid container direction="column" justifyContent="center" alignItems="center">
            <OktaLoginWidgetWrapper config={config} onSuccess={handleSuccess} onError={handleError} />
        </Grid>
    );
};

OktaLogin.propTypes = {
    config: PropTypes.object,
};

export { OktaLogin, OktaLoginWidgetWrapper };
